export enum HeaderVariant {
  SMALL = 'small',
  BIG = 'big',
}
